// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"searchBar_searchBar_3IH8W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/personal/common/searchBar/searchBar.scss
// module id = 1552
// module chunks = 0